module.exports = __webpack_public_path__ + "img/absorbente17.5c4a3ce0.jpg";